export const theme = {
  colors: {
    // Primary colors
    primary: '#3b82f6',
    primaryDark: '#2563eb',
    primaryLight: '#93c5fd',
    
    // Background colors
    bgPrimary: '#ffffff',
    bgSecondary: '#f8fafc',
    bgTertiary: '#f1f5f9',
    
    // Text colors
    textPrimary: '#1e293b',
    textSecondary: '#64748b',
    textTertiary: '#94a3b8',
    
    // Border colors1
    borderLight: '#e2e8f0',
    borderMedium: '#cbd5e1',
    borderDark: '#94a3b8',
    
    // State colors
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6',
    
    // Sidebar
    sidebarBg: '#1e293b',
    sidebarText: '#cbd5e1',
    sidebarHover: '#334155',
    sidebarActive: '#3b82f6',
    
    // Right sidebar (Ads)
    adBg: '#fef3c7',
    adBorder: '#fbbf24',
    adText: '#92400e'
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem'
  },
  
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem'
  },
  
  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1)'
  },
  
  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    mono: "'Fira Code', 'Cascadia Code', 'Monaco', 'Consolas', monospace"
  },
  
  transitions: {
    default: 'all 0.2s ease-in-out',
    slow: 'all 0.3s ease-in-out'
  }
};

export const darkTheme = {
  colors: {
    primary: '#60a5fa',
    primaryDark: '#3b82f6',
    primaryLight: '#93c5fd',
    
    bgPrimary: '#0f172a',
    bgSecondary: '#1e293b',
    bgTertiary: '#334155',
    
    textPrimary: '#f1f5f9',
    textSecondary: '#cbd5e1',
    textTertiary: '#94a3b8',
    
    borderLight: '#334155',
    borderMedium: '#475569',
    borderDark: '#64748b',
    
    success: '#34d399',
    error: '#f87171',
    warning: '#fbbf24',
    info: '#60a5fa',
    
    sidebarBg: '#0f172a',
    sidebarText: '#cbd5e1',
    sidebarHover: '#1e293b',
    sidebarActive: '#60a5fa',
    
    adBg: '#78350f',
    adBorder: '#f59e0b',
    adText: '#fef3c7'
  }
};
